import { render, staticRenderFns } from "./wx.vue?vue&type=template&id=7ff5be4a&scoped=true&"
import script from "./wx.vue?vue&type=script&lang=js&"
export * from "./wx.vue?vue&type=script&lang=js&"
import style0 from "./wx.vue?vue&type=style&index=0&id=7ff5be4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff5be4a",
  null
  
)

export default component.exports